import { render, staticRenderFns } from "./EscolasLista.vue?vue&type=template&id=4aba4f45&"
import script from "./EscolasLista.vue?vue&type=script&lang=js&"
export * from "./EscolasLista.vue?vue&type=script&lang=js&"
import style0 from "./EscolasLista.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports